// external libs
import 'flowbite';
import Lity from 'lity';
import 'lity/dist/lity.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// custom scripts
import Sliders from './js/Sliders';
import FilterButtons from './js/FilterButtons';

document.addEventListener('DOMContentLoaded', function (e) {
	AOS.init();
	Sliders.init();
	FilterButtons.init();
});
